


































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CircularGauge extends Vue {
  @Prop({ type: Number, default: 100 }) readonly size!: number;
  @Prop({ type: Number, default: 12 }) readonly strokeWidth!: number;
  @Prop({ type: Number, default: 0 }) readonly value!: number;
  @Prop({ type: Number, default: 100 }) readonly maxValue!: number;
  @Prop({ type: String, default: "" }) readonly unit!: string;
  @Prop({ type: String, default: "primary" }) readonly color!: string;

  get center(): number {
    return this.size / 2;
  }

  get radius(): number {
    return (this.size - this.strokeWidth) / 2;
  }

  get circumference(): number {
    return 2 * Math.PI * this.radius;
  }

  get dashOffset(): number {
    const percent = Math.min(this.value / this.maxValue, 1);
    return this.circumference * (1 - percent);
  }

  get displayValue(): string {
    return this.value < 10
      ? this.value.toFixed(1)
      : Math.round(this.value).toString();
  }

  get colorClass(): string {
    return `gauge-${this.color}`;
  }
}
